export default "__VITE_ASSET__bad04698__"